"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpViewAssessment = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var learnosity_constants_1 = require("../../Constants/learnosity.constants");
/**
 * This component renders the learnosity preview assessment functionality.
 * Every event related to the component should be registered here.
 *
 * Reference: https://reference.learnosity.com/items-api
 */
var DpViewAssessment = function (_a) {
    var signedRequest = _a.signedRequest, exitHandler = _a.exitHandler, itemNavigationHandler = _a.itemNavigationHandler, _b = _a.resetOnInit, resetOnInit = _b === void 0 ? true : _b;
    (0, react_1.useEffect)(function () {
        var learnosityApi = window[learnosity_constants_1.LEARNOSITY_ITEMS_API];
        if (resetOnInit) {
            if (learnosityApi.reset) {
                learnosityApi === null || learnosityApi === void 0 ? void 0 : learnosityApi.reset();
            }
        }
        var itemsApp = learnosityApi.init(signedRequest, {
            errorListener: function (e) {
                console.log(e);
            },
            readyListener: function () {
                var assessApp = itemsApp.assessApp();
                assessApp.on('test:finished:submit', function () {
                    if (exitHandler) {
                        exitHandler();
                    }
                });
                assessApp.on('item:goto', function (event) {
                    if (itemNavigationHandler) {
                        itemNavigationHandler(event);
                    }
                });
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signedRequest]);
    return (0, jsx_runtime_1.jsx)("div", { id: "learnosity_assess" });
};
exports.DpViewAssessment = DpViewAssessment;
